import React, {Component} from 'react'
import SelectSegments from './../../../components/Select/Books/SelectSegments'
import './../filter.css'

class FilterAdvanced extends Component {
  constructor (props) {
    super(props)
    this.filterSelects = []
  }

  mapSelectOptions = (type) => {
    return type.items.map((item) => {
      return { label: item.name, value: item.id, changeHandler: item.changeHandler, disabled: item.disabled }
    })
  }

  clearFilter = () => {
    this.filterSelects.forEach(select => {
      if (select) select.resetValue()
    })
  }

  render () {
    const { filters, checkUnit } = this.props
    return (
      <div className='select-filter__wrapper' onClick={checkUnit}>
        {
          filters.map(filter =>
            (
              <div className='select-filter__container' key={`filter_${filter.name}`}>
                <span className='select-filter__label'>{filter.label}: </span>
                <SelectSegments
                  options={this.mapSelectOptions(filter.type)}
                  isLoading={filter.type.isFetching}
                  placeholder={filter.placeholder}
                  changeFilter={filter.changeHandler}
                  type={filter.name}
                  multi
                  clearable
                  searchable
                  minWidth={filter.options}
                  disabled={filter.disabled}
                  ref={(element) => { this.filterSelects.push(element) }}
                />
              </div>)
          )
        }
      </div>
    )
  }
}

export default FilterAdvanced



// WEBPACK FOOTER //
// ./src/components/Filter/FilterAdvanced/index.js